export default [
  {
    path: '/tramitados',
    name: 'tramitados',
    component: () => import(/* webpackChunkName: "tramitados" */ './Tramitados.vue')
  }
]
